export class Utility {
    id: number;
    title: string;

    selected: boolean;

    constructor(id, title) {
        this.id = id;
        this.title = title;
    }
}

export default Utility;
